<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("update") }} {{ $t("shiftclose") }}
      </div>
      <router-link class="btn-blue" to="shifts-close"
        >{{ $t("shiftclose") }} {{ $tc("list", 2) }}</router-link
      >
      <a
        v-if="pdfFileLink.length > 0"
        :href="pdfFileLink"
        target="_blank"
        download
        title="Download as PDF"
      >
        <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
      </a>
    </div>
    <div class="d-flex justify-content-between">
      <!-- User starts here -->

      <div class="card-payment-contianer white-wrapper w-50">
        <div class="section-title mb-3">User (As per system)</div>

        <div class="row">
          <ul class="list-unstyled">
            <li
              v-for="(PaymentItem, PaymentIndex) in getShiftClosePaymentTypes"
              :key="PaymentIndex"
              class="col-12 mb-3"
              :style="getHeight(PaymentItem)"
              v-if="PaymentItem.pm_id != 2 || !isEmpireClient"
            >
              <!-- <div
                v-if="String(PaymentItem.pm_id) === '1'"
                class="input-material "
              >
                <input
                  placeholder="."
                  :value="PaymentItem.amount"
                  type="number"
                  step="any"
                  class="form-control bg-white"
                  disabled
                  @input="
                    oneditShiftClosePaymentHandler({
                      event: $event,
                      name: 'amount',
                      index: PaymentIndex,
                      value: $event.target.value
                    })
                  "
                />
                <label
                  :for="PaymentItem.pm_payment_mode"
                  class="d-block small text-muted"
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
              </div> -->

              <div v-if="PaymentItem.pm_id == 1">
                <label
                  class="d-block small text-muted"
                  :for="PaymentItem.pm_payment_mode"
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
                <div class="row">
                  <div class="col-6">
                    <div class="input-material">
                      <input
                        disabled
                        :class="`form-control bg-grey`"
                        type="number"
                        :value="PaymentItem.system_number_of_slips"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'system_number_of_slips',
                            index: PaymentIndex,
                            value: $event.target.value,
                          })
                        "
                      />
                      <label>No Of Transactions</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-material ml-1 h-auto">
                      <input
                        disabled
                        :class="`form-control bg-grey text-dark`"
                        type="number"
                        step="any"
                        :value="PaymentItem.scs_system_recorded_amount"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'scs_system_recorded_amount',
                            index: PaymentIndex,
                            value: $event.target.value,
                          })
                        "
                      />
                      <label>Amount</label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <label
                  class="d-block small text-muted"
                  :for="PaymentItem.pm_payment_mode"
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
                <div class="row">
                  <div class="col-6">
                    <div class="input-material">
                      <input
                        disabled
                        :class="`form-control bg-grey`"
                        type="number"
                        :value="PaymentItem.system_number_of_slips"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'system_number_of_slips',
                            index: PaymentIndex,
                            value: $event.target.value,
                          })
                        "
                      />
                      <label>No Of Slips</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-material ml-1 h-auto">
                      <input
                        disabled
                        :class="`form-control bg-grey text-dark`"
                        type="number"
                        step="any"
                        :value="PaymentItem.scs_system_recorded_amount"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'scs_system_recorded_amount',
                            index: PaymentIndex,
                            value: $event.target.value,
                          })
                        "
                      />
                      <label>Amount</label>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <template v-if="isEmpireClient">
              <template
                v-for="PaymentItem in getShiftClosePaymentTypes.filter(
                  (z) => z.pm_id == 2
                )"
              >
                <li class="col-12 my-2" style="font-weight: bold;">
                  Card Section :
                </li>
                <li
                  v-for="(item2, indexx) in PaymentItem.system_card_detail_new"
                  :key="'da' + indexx + PaymentItem.pm_id"
                  class="col-12 mb-3"
                  :style="getHeight(PaymentItem)"
                  v-if="PaymentItem.pm_id == 2"
                >
                  <label
                    class="d-block small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    >{{ (item2.card_name || "").toUpperCase() }}</label
                  >
                  <div class="row">
                    <div class="col-6">
                      <div class="input-material">
                        <input
                          disabled
                          :class="`form-control bg-grey`"
                          type="number"
                          :value="item2.no_of_slips"
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'system_number_of_slips',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>No Of Slips</label>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-material ml-1 h-auto">
                        <input
                          disabled
                          :class="`form-control bg-grey text-dark`"
                          type="number"
                          step="any"
                          :value="item2.total_amount"
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'scs_system_recorded_amount',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>Amount</label>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  :key="'da' + PaymentItem.pm_id"
                  class="col-12 mb-3"
                  :style="getHeight(PaymentItem)"
                  v-if="PaymentItem.pm_id == 2"
                >
                  <label
                    class="d-block small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    >{{ PaymentItem.pm_payment_mode }}</label
                  >
                  <div class="row">
                    <div class="col-6">
                      <div class="input-material">
                        <input
                          disabled
                          :class="`form-control bg-grey`"
                          type="number"
                          :value="PaymentItem.system_number_of_slips"
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'system_number_of_slips',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>Total No Of Slips</label>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-material ml-1 h-auto">
                        <input
                          disabled
                          :class="`form-control bg-grey text-dark`"
                          type="number"
                          step="any"
                          :value="PaymentItem.scs_system_recorded_amount"
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'scs_system_recorded_amount',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>Total Amount</label>
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </template>
            <hr />

            <li class="col-12 mb-4" v-if="isEmpireClient">
              <label for="Total" class="d-block small text-muted"
                >Total (Cash + Card + Deliver Credit)</label
              >
              <input
                type="text"
                :value="getTotalAmoutofCashCardDeliveryCreditSystem"
                :disabled="isEmpireClient ? true : isDisabled"
                :class="
                  `form-control ${isEmpireClient ? 'bg-grey' : 'bg-white'}`
                "
              />
            </li>
            <li class="col-12 mb-4" v-if="!isEmpireClient">
              <label for="Total" class="d-block small text-muted"
                >Total Without Voucher/Offer</label
              >
              <input
                type="text"
                :value="shiftClosePaymentTotalSystemWithoutVoucher"
                disabled
                :class="`form-control bg-grey text-dark`"
              />
            </li>

            <li class="col-12 mb-4">
              <label for="Total" class="d-block small text-muted">{{
                !isEmpireClient ? "Total With Voucher/Offer" : "Total"
              }}</label>
              <input
                type="text"
                :value="shiftClosePaymentTotalSystem"
                disabled
                :class="`form-control bg-grey text-dark`"
              />
            </li>
          </ul>
        </div>
      </div>
      <!-- User ends here -->
      <!-- TL starts here -->
      <div class="card-payment-contianer white-wrapper w-50">
        <div class="section-title mb-3">TL</div>

        <div class="row">
          <ul class="list-unstyled">
            <li
              v-for="(PaymentItem, PaymentIndex) in getShiftClosePaymentTypes"
              :key="`${PaymentIndex}-TL`"
              class="col-12 mb-3 mt-2"
              :style="getHeight(PaymentItem)"
              v-if="PaymentItem.pm_id != 2 || !isEmpireClient"
            >
              <!-- <div
                v-if="String(PaymentItem.pm_id) === '1'"
                class="input-material "
              >
                <input
                  placeholder="."
                  :value="PaymentItem.amount"
                  type="number"
                  step="any"
                  class="form-control bg-white"
                  :disabled=isDisabled
                  @input="
                    oneditShiftClosePaymentHandler({
                      event: $event,
                      name: 'amount',
                      index: PaymentIndex,
                      value: $event.target.value
                    })
                  "
                />
                <label
                  :for="PaymentItem.pm_payment_mode"
                  class="d-block small text-muted"
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
              </div> -->

              <div v-if="PaymentItem.pm_id == 1">
                <div class="d-flex" v-if="isOnlyEpix">
                  <label
                    class="small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    ><span style="color:red;font-weight: bold;font-size: 15px;"
                      >*</span
                    >{{ PaymentItem.pm_payment_mode }}</label
                  >
                  <p
                    class="mx-2 bottom-border font-weight-bold"
                    @click="show_modal()"
                    >Cash Denomination</p
                  >
                </div>
                <label
                  v-else
                  class="d-block small text-muted"
                  :for="PaymentItem.pm_payment_mode"
                  ><span style="color:red;font-weight: bold;font-size: 15px;"
                    >*</span
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
                <div class="row">
                  <div class="col-12">
                    <div class="input-material ml-1 h-auto">
                      <!-- :disabled="isDisabled" -->
                      <input
                        required
                        :disabled="isDisabled"
                        :class="
                          `form-control ${isDisabled ? 'bg-grey' : 'bg-white'}`
                        "
                        type="number"
                        step="any"
                        :value="PaymentItem.amount"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'amount',
                            index: PaymentIndex,
                            value: $event.target.value,
                            pm_id: PaymentItem.pm_id,
                          })
                        "
                      />
                      <label>Amount</label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="PaymentItem.pm_id == 9">
                <label
                  class="d-block small text-muted"
                  :for="PaymentItem.pm_payment_mode"
                  ><span
                    v-if="PaymentItem.pm_id == 9"
                    style="color:red;font-weight: bold;font-size: 15px;"
                    >*</span
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
                <div class="row">
                  <div class="col-6">
                    <div class="input-material">
                      <input
                        :disabled="PaymentItem.isfieldDisable"
                        :class="
                          `form-control ${
                            PaymentItem.isfieldDisable ? 'bg-grey' : 'bg-white'
                          }`
                        "
                        type="number"
                        :value="PaymentItem.no_of_slips"
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'no_of_slips',
                            index: PaymentIndex,
                            value: $event.target.value,
                            pm_id: PaymentItem.pm_id,
                          })
                        "
                      />
                      <label>No Of Slips</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-material ml-1 h-auto">
                      <input
                        :disabled="PaymentItem.isfieldDisable"
                        :class="
                          `form-control ${
                            PaymentItem.isfieldDisable ? 'bg-grey' : 'bg-white'
                          }`
                        "
                        type="number"
                        v-model="PaymentItem.amount"
                        placeholder="."
                      />
                      <label>Amount</label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <label
                  class="d-block small text-muted"
                  :for="PaymentItem.pm_payment_mode"
                  ><span
                    v-if="PaymentItem.pm_id == 9"
                    style="color:red;font-weight: bold;font-size: 15px;"
                    >*</span
                  >{{ PaymentItem.pm_payment_mode }}</label
                >
                <div class="row">
                  <div class="col-6">
                    <div class="input-material">
                      <input
                        :disabled="PaymentItem.isfieldDisable"
                        :class="
                          `form-control ${
                            PaymentItem.isfieldDisable ? 'bg-grey' : 'bg-white'
                          }`
                        "
                        type="number"
                        :value="
                          PaymentItem.isfieldDisable
                            ? PaymentItem.system_number_of_slips
                            : PaymentItem.no_of_slips
                        "
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'no_of_slips',
                            index: PaymentIndex,
                            value: $event.target.value,
                            pm_id: PaymentItem.pm_id,
                          })
                        "
                      />
                      <label>No Of Slips</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-material ml-1 h-auto">
                      <input
                        :disabled="PaymentItem.isfieldDisable"
                        :class="
                          `form-control ${
                            PaymentItem.isfieldDisable ? 'bg-grey' : 'bg-white'
                          }`
                        "
                        type="number"
                        step="any"
                        :value="
                          PaymentItem.pm_id == 9
                            ? PaymentItem.amount
                            : PaymentItem.isfieldDisable
                            ? PaymentItem.scs_system_recorded_amount
                            : PaymentItem.amount
                        "
                        placeholder="."
                        @input="
                          oneditShiftClosePaymentHandler({
                            event: $event,
                            name: 'amount',
                            index: PaymentIndex,
                            value: $event.target.value,
                            pm_id: PaymentItem.pm_id,
                          })
                        "
                      />
                      <label>Amount</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
                v-if="
                  String(PaymentItem.pm_id) === '1' &&
                    PaymentItem.user_denomination
                "
                class="input-material my-3 pb-5"
              >
                <label
                  :for="PaymentItem.pm_payment_mode"
                  class="d-block small text-muted"
                  >Cash Denomination</label
                >
                <div class="col-12 pl-0" v-if="PaymentItem.user_denomination">
                  <div class="d-flex flex-wrap">
                    <div
                      v-for="(cashValue, cashValueKey) in [
                        ...JSON.parse(PaymentItem.user_denomination)
                      ]"
                      :key="cashValueKey"
                      class="btn-auto-denomination-container"
                      style="width: calc(100% / 3);"
                    >
                      <button
                        class="btn-multiple d-flex justify-content-center align-items-center"
                      >
                        <div class="counts-money">
                          {{ cashValue.denomination_value }} x
                          {{ cashValue.count }}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
            </li>

            <template v-if="isEmpireClient">
              <div
                v-for="(PaymentItem, PaymentIndex) in getShiftClosePaymentTypes"
                :key="PaymentIndex"
              >
                <li
                  class="col-12 my-2"
                  style="font-weight: bold;"
                  v-if="PaymentItem.pm_id == 2"
                >
                  Card Section :
                </li>
                <li
                  v-for="(item2, indexx) in PaymentItem.user_card_detail_new"
                  :key="indexx + PaymentIndex"
                  class="col-12 mb-3"
                  :style="getHeight(PaymentItem)"
                  v-if="PaymentItem.pm_id == 2"
                >
                  <label
                    class="d-block small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    ><span style="color:red;font-weight: bold;font-size: 15px;"
                      >*</span
                    >{{ (item2.card_name || "").toUpperCase() }}</label
                  >
                  <div class="row">
                    <div class="col-6">
                      <div class="input-material">
                        <input
                          required
                          :class="
                            `form-control ${
                              item2.card_name == 'Other' && !isOnlyEmpireClient
                                ? 'bg-grey'
                                : 'bg-white'
                            }`
                          "
                          :disabled="
                            item2.card_name == 'Other' && !isOnlyEmpireClient
                          "
                          type="number"
                          v-model="item2.no_of_slips"
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'no_of_slips',
                              index: PaymentIndex,
                              value: $event.target.value,
                              isCreditNew: true,
                              NewIndex: indexx,
                              name2: 'no_of_slips',
                            })
                          "
                        />
                        <label>No Of Slips</label>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-material ml-1 h-auto">
                        <input
                          required
                          :class="
                            `form-control  text-dark ${
                              item2.card_name == 'Other' && !isOnlyEmpireClient
                                ? 'bg-grey'
                                : 'bg-white'
                            }`
                          "
                          type="number"
                          step="any"
                          v-model="item2.total_amount"
                          :disabled="
                            item2.card_name == 'Other' && !isOnlyEmpireClient
                          "
                          placeholder="."
                          @input="
                            oneditShiftClosePaymentHandler({
                              event: $event,
                              name: 'amount',
                              index: PaymentIndex,
                              value: $event.target.value,
                              isCreditNew: true,
                              NewIndex: indexx,
                              name2: 'total_amount',
                            })
                          "
                        />
                        <label>Amount</label>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  class="col-12 mb-3"
                  :style="getHeight(PaymentItem)"
                  v-if="PaymentItem.pm_id == 2"
                >
                  <label
                    class="d-block small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    >{{ PaymentItem.pm_payment_mode }}</label
                  >
                  <div class="row">
                    <div class="col-6">
                      <div class="input-material">
                        <input
                          disabled
                          :class="`form-control bg-grey`"
                          v-model="PaymentItem.no_of_slips"
                          placeholder="."
                        />
                        <label>Total No Of Slips</label>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-material ml-1 h-auto">
                        <input
                          disabled
                          :class="`form-control bg-grey text-dark`"
                          v-model="PaymentItem.amount"
                          placeholder="."
                        />
                        <label>Total Amount</label>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </template>
            <hr />

            <li class="col-12 mb-4" v-if="isEmpireClient">
              <label for="Total" class="d-block small text-muted"
                >Total (Cash + Card + Deliver Credit)</label
              >
              <input
                type="text"
                :value="getTotalAmoutofCashCardDeliveryCredit"
                :disabled="isEmpireClient ? true : isDisabled"
                :class="
                  `form-control ${isEmpireClient ? 'bg-grey' : 'bg-white'}`
                "
              />
            </li>

            <li class="col-12 mb-4" v-if="!isEmpireClient">
              <label for="Total" class="d-block small text-muted"
                >Total Without Voucher/Offer</label
              >
              <input
                type="text"
                :value="shiftClosePaymentTotalWithoutVoucher"
                :disabled="isDisabled"
                :class="`form-control ${isDisabled ? 'bg-grey' : 'bg-white'}`"
              />
            </li>
            <li class="col-12 mb-4">
              <label for="Total" class="d-block small text-muted">{{
                !isEmpireClient ? "Total With Voucher/Offer" : "Total"
              }}</label>
              <input
                type="text"
                :value="shiftClosePaymentTotal"
                :disabled="isEmpireClient ? true : isDisabled"
                :class="
                  `form-control ${isEmpireClient ? 'bg-grey' : 'bg-white'}`
                "
              />
            </li>
            <li class="col-12 mb-4" v-if="isEmpireClient">
              <label for="Total" class="d-block small text-muted">Excess</label>
              <input
                type="text"
                :value="
                  Math.abs(
                    shiftClosePaymentTotalSystem - shiftClosePaymentTotal < 0
                      ? shiftClosePaymentTotalSystem - shiftClosePaymentTotal
                      : 0
                  )
                "
                :disabled="isEmpireClient ? true : isDisabled"
                :class="
                  `form-control ${isEmpireClient ? 'bg-grey' : 'bg-white'}`
                "
              />
            </li>
            <li class="col-12 mb-4" v-if="isEmpireClient">
              <label for="Total" class="d-block small text-muted"
                >Shortage</label
              >
              <input
                type="text"
                :value="
                  Math.abs(
                    shiftClosePaymentTotalSystem - shiftClosePaymentTotal > 0
                      ? shiftClosePaymentTotalSystem - shiftClosePaymentTotal
                      : 0
                  )
                "
                :disabled="isEmpireClient ? true : isDisabled"
                :class="
                  `form-control ${isEmpireClient ? 'bg-grey' : 'bg-white'}`
                "
                :style="
                  shiftClosePaymentTotalSystem - shiftClosePaymentTotal
                    ? 'color:red'
                    : ' '
                "
              />
            </li>
          </ul>
          <div class="col-12">
            <div class="input-material ml-1 h-auto">
              <input
                :class="`form-control bg-white text-dark`"
                v-model="tlRemarks"
                placeholder=""
              />
              <label>Remarks</label>
            </div>
          </div>
        </div>
      </div>

      <!-- TL ends here -->
    </div>

    <section v-if="!isDisabled">
      <div class="col-md-12 text-center mb-5">
        <button @click.prevent.stop="openPopupModal()" class="btn-blue">
          {{ $t("update") }} {{ $t("Close Shift") }}
        </button>
      </div>
    </section>
    <b-modal
      id="confirmationPopup"
      ref="confirmationPopup"
      hide-header
      hide-footer
      title="Using Component Methods"
    >
      <div class="d-block text-center font-weight-bold">
        Are you sure you want to save?
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <b-button class="btn-primary mt-3 mr-2" @click="updateTLStatus()"
          >Yes</b-button
        >
        <b-button
          class="btn-primary mt-3 ml-2"
          @click="$bvModal.hide('confirmationPopup')"
          >No</b-button
        >
      </div>
    </b-modal>
    <!-- Cash calculator modal -->
    <b-modal id="cash-popover" hide-footer>
      <div class="pos-cash-calculator">
        <div class="row">
          <div class="col-8 mb-3">
            <h5 class="font-weight-bold mb-3">
              {{ $t("total") }} {{ $t("amount") }} {{ $t("collected") }}
            </h5>
            <input v-model="scr_total_amount_collected" disabled type="text" />
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-8">
                <div class="row mx-0">
                  <div class="w-100">
                    <div class="d-block">
                      <div
                        v-for="(cash, cashKey) in cashDenominations"
                        :key="cashKey"
                        class="mb-1"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="font-weight-bold">{{
                            cash.denomination_value
                          }}</p>
                          <div class="input-material-sm">
                            <input
                              v-model="cash.count"
                              name="cash_value"
                              id="cash_value"
                              type="text"
                              @input="calculateCashDenomination()"
                            />
                          </div>
                        </div>
                        <!-- <button class="btn-calc">
                          {{ cash.denomination_value }}
                        </button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Cash input rows -->
              <div class="col-4 pl-0" v-if="false">
                <div class="d-flex flex-column">
                  <div
                    v-for="(cashValue, cashValueKey) in cashRow"
                    :key="cashValueKey"
                    v-on:click="onRemove(cashValue, cashValueKey)"
                    class="btn-auto-denomination-container"
                    style="width: calc(100% / 3);"
                  >
                    <button
                      class="btn-multiple d-flex justify-content-center align-items-center"
                    >
                      <div class="counts-money">
                        {{ cashValue.denomination_value }} x
                        {{ cashValue.count }}
                      </div>
                      <div class="close-btn">
                        <img
                          class="ml-1"
                          src="@/assets/img/icons/close-button.svg"
                          width="15"
                          height="15"
                        />
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <!-- Cash input rows -->
            </div>
          </div>
        </div>
        <nav></nav>
      </div>
    </b-modal>
    <ManagerAuthLogin
      :moduleName="'UpdateShiftClose'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_PGRefund'"
    />

    <!-- Cash calculator modal -->
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import { Role, CLIENT_NAME } from "@/helper/Role";

  import PosService from "@/services/PosService";
  import MasterService from "@/services/MasterService";
  import Printd from "printd";
  import VueHtml2pdf from "vue-html2pdf";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";

  export default {
    components: {
      VueHtml2pdf,
      ManagerAuthLogin,
    },
    name: "editShiftClose",
    data() {
      return {
        totalShiftClose: 0,
        paymentList: [],
        shiftCloseList: [],
        shift_id: null,
        cashDenominations: [],
        cashRow: [],
        isDisabled: false,
        isEmpireDisable: true,
        isEditedByTLNew: false,
        scr_total_amount_collected: 0.0,
        EjsData: null,
        pdfFileLink: "",
        pdfFinalLink: "",
        manager_user_id: "",
        manager_name: "",
        tlRemarks: "",
        shiftClosePayload: {
          usl_id: null,
          user_shift_id: null,
          pos_user_id: null,
          login_date_time: null,
          logout_date_time: null,
        },
      };
    },
    computed: {
      isEmpireClient() {
        return (
          CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
          CLIENT_NAME.WOW == this.CLIENT_SETUP_NAME ||
          CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME
        );
      },
      isOnlyEmpireClient() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      isOnlyEpix() {
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
      isQfx() {
        return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
      },

      getTotalAmoutofCashCardDeliveryCredit() {
        let amount = 0;
        this.paymentList.map((z) => {
          if (![12, 13, 17, 29, 31, 22, 46, 47].includes(z.pm_id)) {
            amount = amount + parseFloat(z.amount);
          }

          if (["47", "46"].includes(String(z.pm_id))) {
            amount += +parseFloat(z.scs_system_recorded_amount);
          }
        });
        // let creditSaleAmountArr = [];
        // creditSaleAmountArr = this.paymentList.filter((x) => {
        //   if (x.pm_id == 46) {
        //     return x.pm_id == 46;
        //   }
        // });

        // let creditSaleAmount =
        //   CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME && creditSaleAmountArr.length
        //     ? creditSaleAmountArr[0].scs_system_recorded_amount
        //     : 0;

        return +parseFloat(amount).toFixed(this.MIN_FRACTION_DIGITS);
      },

      getTotalAmoutofCashCardDeliveryCreditSystem() {
        let amount = 0;
        this.paymentList.map((z) => {
          if (![12, 13, 17, 29, 31, 22].includes(z.pm_id)) {
            amount = amount + parseFloat(z.scs_system_recorded_amount);
          }
        });
        return +parseFloat(amount).toFixed(this.MIN_FRACTION_DIGITS);
      },
      // ...mapGetters(["getUserShiftPaymentTypes"])
      getShiftClosePaymentTypes() {
        if (this.isEmpireClient) {
          return this.paymentList.filter((t) => {
            return t.pm_id !== 17;
          });
        } else {
          return this.paymentList;
        }
      },
      shiftClosePaymentTotal() {
        if (this.isEmpireClient) {
          let systemamount = 0;
          let amount = 0;
          this.paymentList.map((z) => {
            if (![1, 2, 9].includes(z.pm_id)) {
              systemamount =
                systemamount + parseFloat(z.scs_system_recorded_amount);
            }
          });
          this.paymentList.map((z) => {
            if ([1, 2, 9, 49].includes(z.pm_id)) {
              amount = amount + parseFloat(z.amount);
            }
          });

          return +parseFloat(amount + systemamount).toFixed(
            this.MIN_FRACTION_DIGITS
          );
        } else {
          return this.paymentList.reduce(
            (acc, { amount }) => acc + parseFloat(amount),
            0
          );
        }
      },
      shiftClosePaymentTotalWithoutVoucher() {
        let amount = 0;
        this.paymentList.map((z) => {
          if (![12, 13].includes(z.pm_id)) {
            amount = amount + parseFloat(z.amount);
          }
        });
        return +parseFloat(amount).toFixed(this.MIN_FRACTION_DIGITS);
      },
      shiftClosePaymentTotalSystemWithoutVoucher() {
        let amount = 0;
        this.paymentList.map((z) => {
          if (![12, 13].includes(z.pm_id)) {
            amount = amount + parseFloat(z.scs_system_recorded_amount);
          }
        });
        return +parseFloat(amount).toFixed(this.MIN_FRACTION_DIGITS);
      },

      shiftClosePaymentTotalSystem() {
        return +parseFloat(
          this.paymentList.reduce(
            (acc, { scs_system_recorded_amount }) =>
              acc + parseFloat(scs_system_recorded_amount),
            0
          )
        ).toFixed(this.MIN_FRACTION_DIGITS);
      },

      shiftCloseTLCollectionTotal() {
        return +parseFloat(
          this.paymentList.reduce(
            (acc, { tl_collection_amount }) =>
              acc + parseFloat(tl_collection_amount),
            0
          )
        ).toFixed(this.MIN_FRACTION_DIGITS);
      },
    },
    async beforeMount() {
      const { shift_id } = this.$route.query;
      this.shift_id = shift_id;

      if (shift_id) {
        await this.getPaymentTypes();
        // await this.getSingleViewShiftClose(shift_id);
        this.getShiftCloseDetails(shift_id);
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {
      this.getCashDenominations();
      // this.getRDRPdf();
    },
    methods: {
      calculateCashDenomination() {
        this.cashDenominations.forEach((cashObj) => {
          cashObj.count = parseFloat(cashObj.count ? cashObj.count : 0);
          cashObj.denomination_value = cashObj.denomination_value;
          cashObj.value =
            parseFloat(cashObj.count) * parseFloat(cashObj.denomination_value);
          // if (cashObj.value > 0) {
          //   this.cashRow.push({ ...cashObj })
          // }
        });
        this.scr_total_amount_collected = this.cashDenominations.reduce(
          (acc, { count, denomination_value }) => {
            return (
              acc +
              parseFloat(count ? count : 0) * parseFloat(denomination_value)
            );
          },
          0
        );
        let cashIndex = this.paymentList.findIndex((paymentObj) => {
          return paymentObj.pm_id == 1;
        });

        if (cashIndex >= 0) {
          this.paymentList[cashIndex][
            "amount"
          ] = this.scr_total_amount_collected;

          this.paymentList[cashIndex]["tl_denomination"] = JSON.stringify(
            this.cashDenominations
          );

          this.paymentList[cashIndex][
            "tl_collection_amount"
          ] = this.scr_total_amount_collected;
        }

        let renderArrayCashIndex = this.getShiftClosePaymentTypes.findIndex(
          (paymentObj) => {
            return paymentObj.pm_id == 1;
          }
        );

        if (renderArrayCashIndex) {
          this.getShiftClosePaymentTypes[renderArrayCashIndex][
            "amount"
          ] = this.scr_total_amount_collected;
        }
      },
      onCheckAuthentication(response) {
        console.log(response, "response");
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "UpdateShiftClose") {
            this.$bvModal.hide("authManager_PGRefund");
            this.manager_user_id = user_id;

            this.OnFinalSubmit();
          }
        }
      },
      openPopupModal() {
        if (this.isEditedByTLNew) {
          this.$bvModal.show("authManager_PGRefund");
        } else {
          this.$bvModal.show("confirmationPopup");
        }
      },
      generateReport() {
        // window.open(this.pdfFileLink);
        // return false;
        this.pdfFinalLink = window.URL.createObjectURL(
          new Blob([this.pdfFileLink])
        );
        // this.$refs.html2Pdf.generatePdf();
      },
      // getRDRPdf() {
      //   let payload = {
      //     user_id: [this.$route.query.shift_id]
      //   };
      //   MasterService.GetRdrPdfReport(payload)
      //     .then(result => {
      //       const { data } = result;
      //       this.EjsData = data;
      //       this.pdfFileLink = data.tempFile;
      //     })
      //     .catch(err => {
      //       console.log(err);
      //     });
      // },
      show_modal() {
        this.$bvModal.show("cash-popover");
      },
      getHeight(PaymentItem) {
        if (PaymentItem.pm_id == "1") {
          let height_val = 68;
          let checkCashDomination = PaymentItem.user_denomination
            ? JSON.parse(PaymentItem.user_denomination)
            : [];
          if (checkCashDomination.length > 0) {
            height_val =
              height_val + 70 * Math.ceil(checkCashDomination.length / 3);
          }

          return `height:${height_val}px`;
        } else {
          return `height:65px`;
        }
      },
      getHeightTL(PaymentItem) {
        if (PaymentItem.pm_id == "1") {
          let height_val = 68;
          let checkCashDomination = PaymentItem.tl_denomination
            ? JSON.parse(PaymentItem.tl_denomination)
            : [];

          if (checkCashDomination.length > 0) {
            height_val =
              height_val + 70 * Math.ceil(checkCashDomination.length / 3);
          }

          return `height:${height_val}px`;
        } else {
          return `height:65px`;
        }
      },
      getCashDenominations: function() {
        let loader = this.$loading.show();
        PosService.getCashDenominations()
          .then((result) => {
            const { data } = result;
            loader.hide();

            if (data.status) {
              this.cashDenominations = data.Records;
              this.cashDenominations.map((x) => {
                x["count"] = 0;
                x["value"] = parseInt(x.denomination_value);
                return x;
              });
            } else {
              // this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            // this.$toasted.show(err);
          });
      },
      onAdd: function(data) {
        let index = this.cashRow.findIndex(
          (x) => x.denomination_value == data.denomination_value
        );
        if (index > -1) {
          data.count++;
          this.cashRow[index].value =
            parseFloat(data.denomination_value) * data.count;
        } else {
          data.count++;
          data.value = parseFloat(data.denomination_value);
          this.cashRow.push(data);
        }
        let tempVal = 0;
        this.scr_total_amount_collected = 0;
        this.cashRow.map((x) => {
          tempVal += parseFloat(x.value);
          this.scr_total_amount_collected += +parseFloat(x.value).toFixed(1);
        });
        this.DenominationAdd();
      },
      onRemove: function(data, index) {
        this.scr_total_amount_collected -= data.value;

        this.cashRow = this.cashRow.map((x, key) => {
          if (x.denomination_value == data.denomination_value) {
            x.count = 0;
            x.value = parseFloat(x.denomination_value);
          }
          return x;
        });
        this.cashRow.splice(index, 1);
        this.DenominationAdd();
      },
      DenominationAdd() {
        let checkIndex = this.paymentList.findIndex((z) => {
          return z.pm_id == 1;
        });
        console.log(checkIndex, "scr_total_amount_collected");
        if (checkIndex >= 0 && this.cashRow.length) {
          this.paymentList[checkIndex]["tl_denomination"] = JSON.stringify(
            this.cashRow
          );
          this.paymentList[checkIndex][
            "tl_collection_amount"
          ] = this.scr_total_amount_collected;
        } else {
          this.paymentList[checkIndex]["tl_collection_amount"] = 0;
          this.paymentList[checkIndex]["tl_denomination"] = null;
        }
      },
      onClear: function() {
        this.scr_total_amount_collected = 0;
        this.cashRow.map((x, key) => {
          x.count = 0;
          x.value = parseInt(x.denomination_value);
          return x;
        });

        this.cashRow = [];
        this.DenominationAdd();
      },
      getSingleViewShiftClose: function(shift_id) {
        MasterService.OnGetSingleViewShiftClose({ shift_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.shiftCloseList = data.Records;

                this.paymentList.map((x, index) => {
                  x["scs_system_recorded_amount"] = 0;
                  x["system_number_of_slips"] = 0;
                  x["user_card_detail_new"] = data.payment_mode_array;
                  x["system_card_detail_new"] = [];

                  this.shiftCloseList.map((y) => {
                    if (x.pm_id == y.payment_mode_id) {
                      x["system_card_detail"] = y.system_card_detail;
                      x["user_card_detail_new"] = y.user_card_detail_new;
                      x["system_card_detail_new"] = y.system_card_detail_new;
                      this.paymentList[index]["system_number_of_slips"] =
                        y.system_number_of_slips;
                      this.paymentList[index]["scs_system_recorded_amount"] =
                        y.scs_system_recorded_amount;
                      this.paymentList[index]["user_denomination"] =
                        y.user_denomination || null;
                      this.paymentList[index]["tl_denomination"] =
                        y.tl_denomination || null;
                      this.paymentList[index]["tl_collection_amount"] =
                        y.tl_collection_amount;
                      this.paymentList[index]["tl_slip_count"] =
                        y.tl_slip_count;
                      this.paymentList[index]["no_of_slips"] =
                        y.scs_no_of_slips;
                      this.paymentList[index]["amount"] =
                        y.scs_user_recorded_amount;

                      if (this.paymentList[index]["tl_denomination"]) {
                        this.cashRow = JSON.parse(
                          this.paymentList[index]["tl_denomination"]
                        );
                        this.cashRow.forEach((cashObj) => {
                          let cashDenominationsIndex = this.cashDenominations.findIndex(
                            (cashIndex) => {
                              return (
                                cashIndex.denomination_value ==
                                cashObj.denomination_value
                              );
                            }
                          );

                          if (cashDenominationsIndex >= 0) {
                            this.cashDenominations[cashDenominationsIndex][
                              "count"
                            ] = parseFloat(cashObj.count);
                            this.cashDenominations[cashDenominationsIndex][
                              "denomination_value"
                            ] = cashObj.denomination_value;
                            this.cashDenominations[cashDenominationsIndex][
                              "value"
                            ] = parseFloat(cashObj.value).toFixed(
                              this.MIN_FRACTION_DIGITS
                            );
                            this.scr_total_amount_collected += +parseFloat(
                              this.cashDenominations[cashDenominationsIndex][
                                "value"
                              ]
                            );
                          }
                        });
                      }
                    }
                  });
                });
                this.$forceUpdate();
              }
            } else {
              this.$toasted.show(data.message);
              //
            }
          })
          .catch(this._CatchError);
      },
      getShiftCloseDetails: function(shift_id) {
        MasterService.OnGetSingleShiftClose({ shift_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.shiftClosePayload = {
                  ...this.shiftClosePayload,
                  ...data.Records[0],
                  isEditedByTL: data.Records[0].isEditedByTL,
                  usl_id: data.Records[0].usl_id,
                  user_shift_id: data.Records[0].user_shift_id,
                  pos_user_id: data.Records[0].pos_user_id,
                  login_date_time: data.Records[0].login_date_time,
                  logout_date_time: data.Records[0].logout_date_time,
                };
                this.tlRemarks = data.Records[0].tl_shift_remarks;
                if (this.shiftClosePayload.isEditedByTL == "Y") {
                  // this.isDisabled = true;
                  this.isEditedByTLNew = true;
                }
              }
            } else {
              //
            }
          })
          .catch(this._CatchError);
      },
      oneditShiftClosePaymentHandler: function({
        event,
        name,
        index,
        value,
        isCreditNew,
        NewIndex,
        name2,
        pm_id,
      }) {
        if (isCreditNew) {
          this.paymentList[index]["user_card_detail_new"][NewIndex][name2] =
            value && value.length > 0 && value.replace(/\s/g, "").length > 0
              ? parseFloat(value)
              : 0;

          this.paymentList[index]["amount"] = 0;
          this.paymentList[index]["no_of_slips"] = 0;

          console.log(this.paymentList[index], " this.paymentList[index]");

          this.paymentList[index].user_card_detail_new.map((z) => {
            this.paymentList[index]["amount"] =
              this.paymentList[index]["amount"] + z.total_amount;
            this.paymentList[index]["no_of_slips"] =
              this.paymentList[index]["no_of_slips"] + z.no_of_slips;
          });
        } else {
          console.log("name", name);
          console.log("value", value);
          console.log("this.paymentList", this.paymentList[index]);

          if (pm_id) {
            let findIndex = this.paymentList.findIndex(
              (_pm) => _pm["pm_id"] == pm_id
            );
            if (findIndex > -1) {
              this.paymentList[findIndex][name] =
                value && value.length > 0 ? parseFloat(value) : 0;
            }
          } else {
            this.paymentList[index][name] =
              value && value.length > 0 ? parseFloat(value) : 0;
          }
        }
      },
      getPaymentTypes: function() {
        this.paymentList = [];
        let body = {
          // tableName: "ms_payment_modes",
          // pm_is_active: "Y",
          bs_id: 1,
        };
        MasterService.GetPaymentModes(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                let disableFieldPmIds = [13, 12, 29, 31, 17, 22, 46, 47, 54];
                // this.paymentList =
                if (this.isQfx) {
                  data.Records.push({
                    pm_id: 28,
                    pm_payment_mode: "eSewa Wallet",
                  });
                  console.log("Data is pushed");
                }
                data.Records.push({
                  pm_id: 54,
                  pm_payment_mode: "Prepaid Vouchers",
                });

                data.Records.map((x) => {
                  if (x.pm_id != 53) {
                    x["scs_system_recorded_amount"] = 0;
                    x["no_of_slips"] = 0;
                    x["amount"] = 0;
                    x["tl_collection_amount"] = 0;
                    x["tl_slip_count"] = 0;
                    x["tl_denomination"] = null;
                    x["user_denomination"] = null;
                    if (
                      disableFieldPmIds.includes(x["pm_id"]) &&
                      this.isEmpireClient
                    ) {
                      console.log("trueeeeeeeeeeeeee");
                      x["isfieldDisable"] = true;
                    } else {
                      x["isfieldDisable"] = false;
                    }

                    this.paymentList.push(x);
                  }
                  return x;
                });
              }
              this.getSingleViewShiftClose(this.shift_id);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(this.AdminError);
          });
      },
      OnFinalSubmit: function() {
        let disableFieldPmIds = ["29", "31", "17", "22", "46", "47"];
        this.paymentList.forEach((paymentObj) => {
          if (disableFieldPmIds.includes(String(paymentObj.pm_id))) {
            paymentObj["amount"] = paymentObj.scs_system_recorded_amount;
          }
        });
        let payload = {
          ...this.shiftClosePayload,
          shiftClosePaymentTotal: this.shiftClosePaymentTotalWithoutVoucher,
          tl_shift_remarks: this.tlRemarks,
          paymentList: this.paymentList,
          manager_user_id: this.manager_user_id,
        };
        console.log({ payload });
        MasterService.OnUpdateShiftClose(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$router.replace({
                path: "/cinema-manager/shifts-close",
              });
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      updateTLStatus: function() {
        let payload = {
          shift_id: this.shift_id,
        };
        MasterService.updateTLStatus(payload).then((response) => {
          const { data } = response;
          if (data.status) {
            this.OnFinalSubmit();
          }
        });
      },
    },
  };
</script>
<style scoped>
  .bottom-border {
    border-bottom: 1px solid var(--blue);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftCloseComponent/updateShiftClose.vue